<template>
  <div>
    <div class="mobile-banner" v-if="mobile_component">

      <div class="main-page-banner">
        <banner></banner>
      </div>
    </div>

    <banner v-if="!mobile_component"></banner>

    <div class="container">
      <div class="container container-fixed">
        <div class="position-relative">
          <img class="arrow-right" src="../assets/images/right-btn.png"
               @click="$router.push({ path: 'preparare-si-tranzitie-aptamil' })">
          <img class="arrow-left" src="../assets/images/left-btn.png"
               @click="$router.push({ path: 'cum-construim-sistemul-imunitar' })">
        </div>
      </div>
    </div>

    <section class="continut-aptamil">
      <div class="container px-0 pt-30">

        <div class="d-lg-none text-center">
          <p class="subtitle px-4">Inspirată de 50 de ani de cercetare avansată a laptelui matern, <strong>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></strong> Formula pentru copii de vârstă mică este <strong>special
            conceput să susțină sistemul imunitar¹ al copilului tău</strong>, datorită imuno-nutrienților prezenți în mod natural și în laptele matern¹.</p>
        </div>

        <div class="text-center px-3">
          <div class="title-ap mb-0 heading2">5 motive să alegi<br class="d-md-none"/>
            <h2>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></h2></div>
          <p class="subtitle-ap">Formulă pentru copii de vârstă mică.</p>
        </div>

        <div v-if="!mobile_component" class="col-lg-11 mx-auto continut-aptamil-cards">
          <div class="row justify-content-center px-5">
            <div class="col-lg-4 col-12">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-reteta.png">
                </div>
                <h3>Rețetă avansată</h3>
                <p>Inspirată de peste 50 de ani de cercetare avansată a laptelui matern</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-nutrienti.png">
                </div>
                <h3>Imuno-Nutrienți</h3>
                <p>Vitaminele C&D, în cantitățile adecvate vârstei, contribuie la funcționarea normală a sistemului imunitar</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-fibre.png">
                </div>
                <h3>Fibre</h3>
                <p>Sursă de fibre (GOS/FOS) pentru o dietă echilibrată</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-fara-ulei.png">
                </div>
                <h3>Fără ulei de palmier adăugat</h3>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-srp.png">
                </div>
                <h3>Susținut de Societatea Română de Pediatrie</h3>
              </div>
            </div>
          </div>
        </div>

        <carousel :nav="false" :items=1 :stagePadding=50 :center=true v-else-if="mobile_component" class="pt-4">
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-reteta.png">
              </div>
              <h3>Rețetă avansată</h3>
              <p>Inspirată de peste 50 de ani de cercetare avansată a laptelui matern</p>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-nutrienti.png">
              </div>
              <h3>Imuno-Nutrienți</h3>
              <p>Vitaminele C&D, în cantitățile adecvate vârstei, contribuie la funcționarea normală a sistemului imunitar</p>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-fibre.png">
              </div>
              <h3>Fibre</h3>
              <p>Sursă de fibre (GOS/FOS) pentru o dietă echilibrată</p>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-fara-ulei.png">
              </div>
              <h3>Fără ulei de palmier adăugat</h3>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-srp.png">
              </div>
              <h3>Susținut de Societatea Română de Pediatrie</h3>
            </div>
          </div>
        </carousel>

        <div class="nav-buttons nav-alege">
          <button type="button" id="btAlege" class="btn cumpara-prin" v-on:click="btAlege">
            <img src="../assets/images/pentru-imunitate/icon-buy.png" alt="Cumpără"> <span>Alege Aptamil</span>
          </button>
        </div>
      </div>
    </section>

    <section class="tranzitie-aptamil">
      <div class="container text-center">
        <h2>Cum faci tranziția<br class="d-md-none"/> de la altă formulă la<br class="d-none d-md-block"/> Aptamil<sup>®</sup><br class="d-md-none"/> NUTRI-BIOTIK<sup>TM</sup>?</h2>
        <p>Îți recomandăm să optezi pentru o <strong>tranziție treptată</strong> de la formula anterioară la formula Aptamil, <strong>în 1-2 săptămâni</strong>, conform schemei de mai jos:</p>

        <formula-masura-aptamil></formula-masura-aptamil>

        <p><strong>Combină progresiv cele 2 formule</strong>, înlocuind câte o măsură de pudră din formula anterioară cu o măsură din formula Aptamil, o dată la 2-3 zile, la toate mesele.</p>
        <p class="advice">SFAT: Asigură-te că păstrezi o cutie din formula actuală pentru prepararea combinată. Nu ezita să consulți medicul pediatru.</p>
      </div>
    </section>

    <section class="sfatul-expertului">
      <div class="container">
        <div class="section-content">
          <h2>Cere sfatul expertului</h2>
          <p>Înțelegem că orice schimbare a formulei copilului tău, oricât de mică, vine cu întrebări.</p>

          <div class="d-none d-md-block">
            <p><strong>Olivia, expertul nostru</strong>, te poate ajuta cu sfaturi pentru o tranziție ușoară, dar și cu informații despre disponibilitatea formulelor <strong>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></strong>.</p>
            <div class="mt-5">
              <a href="#" @click="goTo()" target="_blank" class="btn btn-question">
                <img src="../assets/images/formule-aptamil/icon-question.png" alt="Pune o întrebare">
                Pune o întrebare
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="continut-aptamil ambalaj-aptamil">
      <div class="container">
        <div class="d-md-none text-center mb-5">
          <p><strong>Olivia, expertul nostru</strong>, te poate ajuta cu sfaturi pentru o tranziție ușoară, dar și cu informații despre disponibilitatea formulelor <strong>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></strong>.</p>
          <div class="mt-2">
            <a href="#" @click="goTo()" target="_blank" class="btn btn-question">
              <img src="../assets/images/formule-aptamil/icon-question.png" alt="Pune o întrebare">
              Pune o întrebare
            </a>
          </div>
        </div>
      </div>

      <div class="container px-0 pt-30">
        <div class="text-center">
          <h2 class="title-ap mb-0 px-3">Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> are un ambalaj inovator, prietenos cu mediul </h2>
        </div>

        <div v-if="!mobile_component" class="col-lg-11 mx-auto continut-aptamil-cards">
          <div class="row justify-content-center px-5">
            <div class="col-lg-4 col-12">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-electric.png">
                </div>
                <p>Fabrica noastră folosește energie electrică provenind din surse 100% regenerabile</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-ambalaj.png">
                </div>
                <p>Ambalajul nostru este creat parțial din materiale regenerabile pe baza de plante</p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="bk-blue-light2">
                <div class="logo-secret-gold">
                  <img src="../assets/images/formule-aptamil/icon-srp.png">
                </div>
                <p>Împreună creăm un viitor mai mai bun pentru copilul tău</p>
              </div>
            </div>
          </div>
        </div>

        <carousel :nav="false" :items=1 :stagePadding=50 :center=true v-else-if="mobile_component" class="pt-4">
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-electric.png">
              </div>
              <p>Fabrica noastră folosește energie electrică provenind din surse 100% regenerabile</p>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-ambalaj.png">
              </div>
              <p>Ambalajul nostru este creat parțial din materiale regenerabile pe baza de plante</p>
            </div>
          </div>
          <div class="slider-item">
            <div class="bk-blue-light2">
              <div class="logo-secret-gold">
                <img src="../assets/images/formule-aptamil/icon-srp.png">
              </div>
              <p>Împreună creăm un viitor mai mai bun pentru copilul tău</p>
            </div>
          </div>
        </carousel>
      </div>
    </section>


    <section class="slide-produse">
      <div class="slide-produse">
        <div class="row text-center position-relative">
          <div class="title-ap text-center w-100 mb-5 px-5">Știi ce produs i se potrivește?</div>
          <slick></slick>
        </div>
      </div>
    </section>


    <div class="container position-relative">
      <section class="question formula-aptamil">
        <div>
          <h2>5 întrebări frecvente despre <br/>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup></h2>
        </div>
        <div class="services-left accordion" id="servicesAccordion">
          <div class="col-feature row-eq-height mx-auto">
            <div class="feature row-eq-height mb-4 ripple collapsed" feature-border="2"
                 data-toggle="collapse" href="#collapseServicesTwo" role="button" aria-expanded="false"
                 aria-controls="collapseServicesTwo">
              <div class="feature-content question-content">
                <div class="text-center">
                  <p>Cum prepar Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>?</p>
                </div>
                <div class="collapse" id="collapseServicesTwo" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">Poți prepara formula de lapte Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> urmând 5 pași simpli. Descoperă indicațiile de preparare înscrise pe ambalaj, în secțiunea „Prepararea unei mese”.</p>
                  <a href="https://www.youtube.com/watch?v=XbMOB996RAo"
                     target="_blank" style="color: #029FE3; font-size: 12px">Urmărește-l
                    aici! </a>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-feature row-eq-height mx-auto">
            <div class="feature collapsed row-eq-height mb-4 ripple" feature-border="3"
                 data-toggle="collapse" href="#collapseServicesThree" role="button"
                 aria-expanded="false" aria-controls="collapseServicesThree">
              <div class="feature-content question-content">
                <div class="text-center">
                  <p>Ce conține formula pentru copii de vârstă mică Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>?</p>
                </div>
                <div class="collapse" id="collapseServicesThree" data-parrent="#servicesAccordion">
                  <p class="blue2">După laptele matern, Aptamil este alegerea potrivită pentru a-i asigura o alimentație adecvată micuțului tău. Inspirați de peste 50 de ani de cercetare avansată a laptelui matern,
                    am dezvoltat formula pentru copii de vârstă mică Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup>, ce conțin mixul nostru de ingrediente:<br/>
                    <strong>Imuno-Nutrienți</strong>: vitaminele C&D contribuie la funcționarea normală a sistemului imunitar;<br/>
                    <strong>Fibre</strong>: GOS/FOS<sup>2</sup><br/>
                    <strong>Nutrienți esențiali</strong> pentru o creștere armonioasă:<br/>
                    • Calciu contribuie la dezvoltarea normală a oaselor;<br/>
                    • Iod contribuie la dezvoltarea cognitivă normală;<br/>
                    • Omega 3 (DHA).
                  </p>
                  <div>
                    <router-link :to="{ 'name' : 'PreparareFormule', 'params' : { 'top' : true} }"
                                 v-slot="{ href, navigate}">
                      <a style="color: #029FE3; font-size: 12px" :href="href" @click="navigate">Află mai multe</a>
                    </router-link>
                  </div>

                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-feature row-eq-height mx-auto">
            <div class="feature row-eq-height mb-4 ripple riple-service collapsed" feature-border="1"
                 data-toggle="collapse" href="#collapseServicesFour" role="button" aria-expanded="false"
                 aria-controls="collapseServicesFour">
              <div class="feature-content question-content">
                <div class="text-center">
                  <p>Care sunt beneficiile formulei Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+?</p>
                </div>
                <div class="collapse" id="collapseServicesFour" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">Formula Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+ este special concepută pentru a răspunde nevoilor nutriționale ale copilului tău aflat în continuă creștere și dezvoltare.
                    În primii ani de viață se pun bazele sistemului său imunitar. <strong>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+</strong> susține sistemul imunitar al copilului tău, datorită imuno-nutrienților prezenți în mod natural și în laptele matern, iar vitaminele C&D contribuie la buna funcționare a sistemului imunitar. Vitaminele C&D se numără printre nutrienții prezenți în mod natural și în laptele matern.</p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-feature row-eq-height mx-auto">
            <div class="feature row-eq-height mb-4 ripple collapsed" feature-border="2"
                 data-toggle="collapse" href="#collapseServicesFive" role="button" aria-expanded="false"
                 aria-controls="collapseServicesFive">
              <div class="feature-content question-content">
                <div class="text-center">
                  <p>Este mai bună formula de lapte praf Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+ față de o altă formulă?</p>
                </div>
                <div class="collapse" id="collapseServicesFive" data-parrent="#servicesAccordion"
                     style="">
                  <p class="blue2">De peste 50 de ani, la NUTRICIA cercetăm laptele matern pentru a înțelege nevoile nutriționale ale sugarilor și copiilor mici, iar acest lucru ne ajută să inovăm în permanență.<br/>
                    Din formula Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> a fost înlăturat uleiul de palmier pentru a veni în întâmpinarea preferințelor consumatorilor față de produsele fără ulei de palmier adăugat.
                    Acum NUTRI-BIOTIK conține un amestec de uleiuri vegetale format din ulei de floarea-soarelui bogat în acid oleic, ulei de cocos, ulei de rapiță.<br/>
                    Mai mult, formulele Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> vin într-un ambalaj conceput și el din grijă pentru planetă.
                  </p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
          <div class="col-feature row-eq-height mx-auto">
            <div class="feature collapsed row-eq-height mb-4 ripple" feature-border="3"
                 data-toggle="collapse" href="#collapseServicesSix" role="button" aria-expanded="false"
                 aria-controls="collapseServicesSix">
              <div class="feature-content">
                <div class="text-center">
                  <p>Ce tip de lapte este potrivit după vârsta de 1 an?</p>
                </div>
                <div class="collapse" id="collapseServicesSix" data-parrent="#servicesAccordion">
                  <p class="blue2">Chiar și după vârsta de un an, copilul tău are nevoi nutriționale specifice. Oferă-i formula Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+ special concepută să susțină sistemul imunitar¹
                    al copilului tău, datorită imuno-nutrienților prezenți în mod natural și în laptele matern¹.<br/>
                    500 ml de Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> 1+, pe zi, acoperă mare parte din necesarul de vitamine și minerale în această etapă de vârstă.<br/>
                    Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> Formulă pentru copii de vârstă mică, este recomandat de către Societatea Română de Pediatrie.
                  </p>
                </div>
              </div>
              <i class="services-arrow"></i>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section>
      <div class="container">
        <div class="footer-text">
          <p class="pb-2">FOARTE IMPORTANT</p>
          <p>Laptele matern este cea mai bună hrană pentru copilul tău, astfel că alăptarea trebuie să dureze o perioadă cât mai îndelungată. Se recomandă alăptarea exclusivă cu lapte matern pentru sugarii cu vârsta de până la 6 luni. Se folosește numai la indicația și sub
            îndrumarea medicului sau asistentului medical și numai după instruirea mamei privind utilizarea produsului.</p><br/>
          <p>Aptamil<sup>®</sup> NUTRI-BIOTIK<sup>™</sup> Formulă pentru copii de vârstă mică face parte dintr-o dietă variată și echilibrată.</p>
          <p><sup><strong>1</strong></sup>Vitaminele C și D contribuie la buna funcționare a sistemului imunitar. Vitaminele C și D se numără printre nutrienții prezenți în mod natural și în laptele matern.</p>
          <p><sup><strong>2</strong></sup>GOS/FOS imită structura oligozaharidelor prezente în laptele matern.</p>
        </div>
      </div>
    </section>

  </div>
</template>


<script>
import Slick from '../components/FormuleAptamil/Slick.vue'
import Banner from '../components/FormuleAptamil/Banner.vue'
import FormulaMasuraAptamil from '../components/FormuleAptamil/FormulaMasuraAptamil.vue'
import carousel from 'vue-owl-carousel'

export default {
  props: ["mobile_component"],
  components: {
    'slick': Slick,
    'FormulaMasuraAptamil': FormulaMasuraAptamil,
    'banner': Banner,
    carousel,
  },
  data() {
    return {}
  },
  methods: {
    goTo() {
      window.fbq('track', 'Intreaba-Expertii');
      window.gtag('event', 'click', { 'event_category': 'nutri-pune-intrebare' });
      window.open("https://www.aptanutricia.ro/intreaba-expertii", '_blank');
    },

    btAlege() {
      document.getElementById('btAlege').classList.toggle('open');
      document.getElementById('buy1').classList.toggle('show-buy')
      var offsets = document.getElementById('btAlege').getBoundingClientRect();
      document.getElementById('buy1').style.top = offsets.top + window.scrollY + 'px';
      document.getElementById('buy1').style.left = offsets.left + 'px';
    },
  }
}
</script>


<style lang="scss">
.nav-alege {
  padding-top: 30px;
  padding-bottom: 60px;
  text-align: center;

  .btn.cumpara-prin {
    padding: 0.25rem 1rem;
  }
}

.footer-text {
  text-align: center;

  p {
    color: #001489;
    margin-bottom: 0;
    font-size: 11px;
  }
}

.slide-produse {
  position: relative;
  padding-bottom: 50px;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 65%;
    background-color: #abcae9;
    bottom: 0;
  }
}

.question.formula-aptamil,
.sfatul-expertului,
.tranzitie-aptamil {
  padding: 60px 0;
  font-family: 'Montserrat', sans-serif;

  h2 {
    color: #001489;
    font-size: 40px;
    line-height: 1.2;
    font-weight: 700;
    padding-bottom: 50px;
  }

  p {
    color: #001489;
    font-size: 21px;

    strong {
      font-weight: 700;
    }

    &.advice {
      padding: 30px 0;
      font-size: 16px;
    }
  }
}

.question.formula-aptamil {
  padding: 30px 0;
}

.sfatul-expertului {
  padding-bottom: 0;
  text-align: center;
  background: #DFF1FD url("../assets/images/formule-aptamil/expert-bg.jpg") no-repeat top center;
  background-size: cover;
  max-width: 1600px;
  margin: 0 auto;

  .section-content {
    margin-top: 440px;
    padding: 40px;
    background: rgba(255, 255, 255, 0.9);
  }
}

.btn.btn-question {
  background-color: #001489;
  color: #fff;
  border-radius: 100px;
  padding: 15px 40px;

  img {
    max-height: 40px;
    margin-right: 10px;
  }
}

.nut-banner.banner-formule-two {
  height: inherit;
}

.nut-banner.banner-formule-two .row {
  height: inherit;
  align-items: center;
}

.nut-banner.banner-formule-two {
  height: 513px;
  position: relative;
}

.logo-secret-gold img {
  min-height: 55px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.question {
  margin-top: 100px;
}

.nut-banner h1 span {
  font-size: 40px;
  font-weight: 900;
  line-height: 20px;
}

.mobile-version {
  display: none;
}

.contact-experts-icons {
  background: #029FE3;
  padding: 10px;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ask-experts {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1028px;
  margin: 40px auto;

  .ask-experts-info {
    .ask-experts-title {
      font-size: 40px;
      color: #17479E;
      font-weight: 700;
    }

    .ask-experts-text {
      font-size: 18px;
      color: #707070;
    }
  }

  .contact-box {
    display: flex;
    justify-content: space-evenly;
    align-items: center;


    .contact-box-h {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 110px;

      .contact-experts-icons {
        margin-bottom: 10px;
      }

      p {
        display: flex;
        align-items: center;
        color: #009FE3;
        font-weight: 600;
      }

    }
  }
}

.blue-bg {
  position: absolute;
  top: 240px;
}

.services-left .feature {
  background: #C4E4F9;
}

#servicesAccordion .feature.collapsed {
  background: #C4E4F9;
  cursor: pointer;
}

.formula-aptamil {
  .services-left .feature {
    background: #e0e8f0;
    border-radius: 0;
    max-width: 100%;

    p {
      color: #001489 !important;
    }

    p.blue2 {
      color: #001489 !important;
    }
  }

  #servicesAccordion .feature.collapsed {
    background: #f1f8ff;
    cursor: pointer;

    .feature-content {
      p {
        color: #001489 !important;
      }
    }
  }
}


.nut-banner h1 {
  color: #17479E;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0.5rem;
  line-height: 40px;
  margin-top: 25px;
  position: relative;
}

.continut-aptamil-cards {
  margin-top: 50px;
}

.nut-banner .btn-cumpara {
  color: #fff;
  background: #029FE3;
  font-size: 16px;
  font-weight: 800;
  border-radius: 25px;
  width: 190px;
  height: 50px;
  margin-top: 0;
}

.nut-banner .btn-cumpara.bt-mobile {
  display: none;
}

.title-ap {
  font-size: 40px;
  font-weight: 700;
  color: #001489;
  line-height: 44px;
  text-transform: none;

  h2 {
    font-size: 40px;
    font-weight: 700;
    color: #001489;
    line-height: 44px;
  }
}

.subtitle-ap {
  font-weight: 40;
  color: #001489;
  font-size: 30px;
  line-height: 33px;
}

.btn-afla {
  color: #029FE3;
  background: transparent;
  font-size: 14px;
  font-weight: 800;
  border: 1px solid #009FE3;
  border-radius: 25px;
  width: 100%;
  height: 50px;
  margin-top: 30px;
  max-width: 290px;
}

.buy-from {
  color: #029FE3;
  background: transparent;
  font-size: 14px;
  font-weight: 800;
  border: 1px solid #009FE3;
  border-radius: 25px;
  text-transform: uppercase;
  width: 180px;
  height: 40px;
  margin: auto;
  margin-top: 10px;

  img {
    max-height: 30px;
    width: auto;
    max-width: 60%;
  }
}

.cumpara-prin {
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  border: 1px solid #009FE3;
  border-radius: 25px;
  width: 235px;
  height: 50px;
  margin-top: 15px;
  background: #009FE3;
  display: flex;
  align-items: center;
  margin-left: 35px;
  justify-content: space-around;
  max-width: 290px;
  margin: 10px auto;
  outline: none;
  box-shadow: none !important;
}

.cumpara-prin:hover {
  color: white;
  transition: 0.3s all ease;
  background: #17479E;
  border-color: #17479E;
}

.cumpara-prin.btn[aria-expanded="true"] {
  border-radius: 30px 30px 0 0;
}

.btn-afla {
  transition: 0.3s all ease;
}

.btn-afla:hover {
  color: #17479E;
  border: 1px solid #17479E;
  cursor: pointer;
}

.btn-afla.focus,
.btn-afla:focus {
  outline: 0;
  box-shadow: none;
}


.continut-aptamil h3 {
  font-size: 20px;
  font-weight: 700;
  color: #029FE3;
}

.slider-item {
  margin-right: 30px;
}

.bk-blue-light {
  background: #F1F8FF;
  border-radius: 20px;
  padding: 30px;
  margin: 15px 0;
  min-height: 185px;
  max-height: 185px;
}

.bk-blue-light2 {
  background: #f1f8ff;
  padding: 70px 15px 15px 15px;
  text-align: center;
  margin: 45px 0 50px 0;
  min-height: 226px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  h3 {
    font-size: 23px;
    color: #001489;
  }

  p {
    font-size: 14px;
    color: #001489;
    margin-bottom: 0;
  }
}

.ambalaj-aptamil .bk-blue-light2 p {
  font-size: 16px;
}

.logo-secret {
  min-height: 55px;
}

.slide-produse {
  margin-top: 60px;
  margin-bottom: -35px;
}

.slide-produse .title-ap {
  margin-bottom: 30px;
}

.modal-dialog {
  max-width: 1138px;
  margin: 1.75rem auto;
}

.modal-content {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, .2);
  border-radius: 30px;
  outline: 0;
}

.modal-content h3 {
  font-size: 30px;
  color: #17479E;
  font-weight: 900;
}

.modal-content ol {
  padding-left: 20px;
}

.modal-content .nav-item {
  border-bottom: 2px solid #CCCCCC;
  position: relative;
}

.height-400 .continut-aptamil {
  padding: 50px 0 0 0;
  margin-bottom: 40px;
  background-color: #abcae9;

  .subtitle {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 50px;
    color: #001489;
  }
}

.modal-content li,
.modal-content p {
  text-align: left;
  color: #707070;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
}

.modal-content .tab-content p {
  line-height: 30px;
  padding-right: 20px;
}

.modal-content .nav-tabs .nav-item.show .nav-link,
.modal-content .nav-tabs .nav-link.active {
  color: #17479E;
  font-weight: 700;
  font-size: 18px;
  background-color: #fff;
}

.modal-content .nav-tabs .nav-link.active:after {
  content: "";
  float: left;
  position: absolute;
  background: #17479E;
  width: 100%;
  height: 4px;
  border-radius: 3px;
  margin-top: 5px;
  bottom: -3px;
  left: 0;
  right: 0;
  margin: auto;
}

.modal-content a {
  color: #CCCCCC;
  font-weight: 700;
  font-size: 18px;
}

.modal-content .nav-tabs {
  border-bottom: none;
}

.modal-content .nav-tabs .nav-link {
  border: 2px solid transparent;
}

.question h2 {
  font-size: 28px;
  font-weight: 700;
  color: #17479E;
  text-align: center;
  padding-bottom: 20px;
}

.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.feature.collapsed {
  background: white;
}

.services-left .feature {
  padding: 19px 20px;
}

.ripple {
  position: relative;
  z-index: 2;
}

.ripple::after,
.ripple::before {
  position: absolute;
  z-index: -1;
  display: block;
  content: '';
}

.feature h5 {
  margin: 15px 0 5px;
  color: #029FE3 !important;
  font-weight: 900;
  font-size: 16px;
}

.feature p {
  color: #17479E !important;
  font-size: 14px !important;
  font-weight: 600;
  margin-bottom: 0;
}

.feature p.blue2 {
  color: #707070 !important;
  font-size: 14px !important;
  font-weight: 400;
  margin-bottom: 0;
  width: 95%;
  margin-top: 20px;
}

.ripple,
.ripple::after,
.ripple::before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.feature-content {
  width: 95%;
}

.feature {
  border-radius: 20px;
  max-width: 746px;
  background: #fff;
  padding: 0 25px 20px;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  z-index: 1;
  margin: auto;
}

.feature.collapsed .feature-arrow,
.feature.collapsed .services-arrow {
  transform: rotate(0deg);
}

.feature .feature-arrow,
.feature .services-arrow {
  transform: rotate(180deg);
}

.feature-arrow,
.services-arrow {
  transition: 0.3s transform linear;
}

.feature-arrow,
.services-arrow {
  display: inline-block;
  height: 32px;
  background-repeat: no-repeat;
  width: 32px;
  position: relative;
}

.services-features .feature .services-arrow {
  background-image: url("../assets/images/image-secretele-laptelui/arrow-up.png");
}

.feature .feature-arrow.purple-arrow,
.feature .services-arrow,
.feature.collapsed .services-arrow,
section.high-standard .feature.collapsed:hover .feature-arrow.purple-arrow {
  cursor: pointer;
  background-image: url("../assets/images/image-secretele-laptelui/arrow-down.png");
}

section.blue-dark {
  background: #17479E;
  padding: 60px 0;
  margin-bottom: 0;
  position: relative;
  z-index: 9;
}

.blue-dark h2 {
  color: #C4E4F9;
  font-weight: 700;
  font-size: 40px;
}

.blue-dark p {
  color: #C4E4F9;
  font-weight: 500;
  font-size: 18px;
}

.btn-intreaba {
  color: #fff;
  background: #029FE3;
  font-size: 14px;
  font-weight: 800;
  border: 1px solid #009FE3;
  border-radius: 25px;
  text-transform: uppercase;
  width: 190px;
  height: 50px;
  margin-top: 0;
}

.slide-produse .carouselOne img {
  pointer-events: none;
  max-width: 324px;
  max-height: 429px;
}

.nut-banner.banner-formule-two .pack {
  max-width: 583px;
  max-height: 315px;
}

@media only screen and (max-width: 1200px) {
  .nut-banner h1 span {
    font-size: 30px;
    font-weight: 900;
    line-height: 20px;
  }
}

@media only screen and (max-width: 992px) {
  .modal-content .tab-content p {
    padding-right: 0;
  }

  .sfatul-expertului {
    background-position: 80%;
  }

  .slide-produse .title-ap {
    text-align: center;
  }
  .nut-banner.banner-formule-two {
    margin: 20px 0;
    max-height: 500px;
  }
  .nut-banner.banner-formule-two h1 span:before {
    content: none;
  }
  .nut-banner.banner-formule-two .row {
    text-align: center;
  }
  .nut-banner.banner-formule-two .pack {
    height: 300px;

  }
  .continut-aptamil .title-ap,
  .produse .title-ap,
  .slide-produse .title-ap {
    font-size: 26px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;

    h2 {
      font-size: 26px;
      font-weight: 700;
      line-height: 30px;
    }
  }
  .slide-produse .carouselOne img {
    max-height: 190px;
    margin: 0 auto;
  }
  .produse .title-ap br {
    display: none;
  }
  .nut-banner .btn-cumpara.bt-mobile {
    display: block;
    margin: 0 auto;
    width: 80%;
  }
  .nut-banner .btn-cumpara.bt-desktop {
    display: none;
  }
  section.question {
    margin-top: 40px !important;
  }
  .blue-dark h2 {
    font-size: 28px;
  }
  .blue-dark p {
    font-size: 14px;
  }
  .slide-produse {
    margin-top: 30px;
    margin-bottom: 0;
    padding-bottom: 15px;
  }

  .height-400 .continut-aptamil .subtitle {
    margin-bottom: 30px;
  }
}

@media only screen and (max-width: 768px) {
  .formula-masura-aptamil .legend p {
    font-size: 14px;
  }

  .formula-masura-aptamil .legend .dot {
    width: 14px;
    height: 14px;
    margin-bottom: -3px;
    margin-right: 10px;
  }

  .formula-masura-aptamil .border-light p {
    display: flex;
    margin: 3px 0;
  }

  .height-400 .continut-aptamil {
    padding-top: 15px;
  }

  .question.formula-aptamil h2,
  .sfatul-expertului h2,
  .tranzitie-aptamil h2 {
    font-size: 23px;
    padding-bottom: 15px;
  }

  .question.formula-aptamil p,
  .sfatul-expertului p,
  .tranzitie-aptamil p {
    font-size: 16px;
  }

  .sfatul-expertului {
    .section-content {
      padding: 30px 15px 15px 15px;
    }

    p {
      margin-bottom: 0;
    }
  }

  .btn.btn-question {
    padding: 5px 15px;
    font-size: 14px;
  }

  .continut-aptamil .title-ap,
  .produse .title-ap,
  .slide-produse .title-ap {
    font-size: 22px;

    h2 {
      font-size: 22px;
    }
  }

  .subtitle-ap {
    font-size: 16px;
    margin-bottom: 0;
  }

  .banner-formula-two .banner-content {
    padding: 30px 30px 15px 30px;
  }

  .question.formula-aptamil p.advice,
  .sfatul-expertului p.advice,
  .tranzitie-aptamil p.advice {
    padding: 15px 0 0 0;
    margin-bottom: 0;
    font-size: 14px;
  }
}

@media only screen and (max-width: 576px) {
  .continut-aptamil .slider-item {
    margin-left: 30px;
    margin-right: 0;
  }

  .logo-secret-gold img {
    margin-left: 30px !important;
  }

  .blue-bg {
    top: 170px;

  }

  .title-ap-margin {
    margin-top: 70px;
  }

  .ask-experts .contact-box {
    align-items: flex-start;
  }
  .nut-banner h1 {
    width: 70%;
    margin: auto !important;
  }

  //.bk-blue-light2 {
  //  margin-top: 40px;
  //  text-align: left;
  //
  //  img {
  //    width: 89px;
  //    top: -40px;
  //    height: 89px;
  //  }
  //}
  .btn-afla {
    width: 100%;
    max-width: 290px;
  }
  .cumpara-prin {
    margin-left: 0;
    width: 100%;
    max-width: 290px;
    margin: 10px auto;
  }
  .ask-experts {
    text-align: center;

    .ask-experts-info {
      .ask-experts-title {
        font-size: 26px;
        width: 100%;
      }
    }

  }
  .nut-banner.banner-formule-two {
    padding-top: 20px;
    height: 430px;
    position: relative;
  }
  .nut-banner.banner-formule-two .pack {
    height: auto;
    max-height: 145px;
    max-width: 269px;

  }
}

@media screen and (max-width: 375px) {
  .blue-bg {
    top: 190px;

  }
}

.banner-formule-img{
  max-width: 160%;
}
</style>